import React, { useEffect, useState } from "react";
import MainContainer from "../../../container/MainContainer";
import Arrow from "../../../images/Arrow-Right.svg";
import { Link } from "react-router-dom";
import download from "../../../images/DownloadCsv.svg";
import ActiveDealTable from "./ActiveDealTable";
import { useLazyQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../../apolloClient";
import { GET_ACTIVE_DEALS } from "../../../query/getActiveDeals";
import { GET_DEALS } from "../../../query/getDeals";
import moment from "moment";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ActiveDealDetails = () => {
  const [data, setData] = React.useState([]);
  const [dataSet, setDataSet] = useState([]);

  const [pageCount, setPageCount] = React.useState(0);

  const [
    getActiveDeals,
    {
      data: activeDealsData,
      loading: activeDealsLoading,
      error: activeDealsError,
    },
  ] = useLazyQuery(GET_ACTIVE_DEALS, {
    client: hasuraClient,
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
      club_profile_id: localStorage.getItem("profile_id"),
      current_date_time: moment().format(),
    },
  });

  // uncomment this for showing only active deal
  // const [
  //   getActiveDeals,
  //   {
  //     data: activeDealsData,
  //     loading: activeDealsLoading,
  //     error: activeDealsError,
  //   },
  // ] = useLazyQuery(GET_DEALS, {
  //   fetchPolicy: "cache-and-network",
  //   client: hasuraClient,
  // });

  useEffect(() => {
    getActiveDeals({
      variables: {
        business_profile_id: localStorage.getItem("profile_id"),
        current_date_time: moment().format(),
        search_text: "%%",
        order_by: { created_at: "desc" },
      },
    });
    //uncomment this for showing only active deals
    // getActiveDeals({
    //   variables: {
    //     searchText: "%%",
    //     id: localStorage.getItem("profile_id"),
    //     type: null,
    //     current_date_time: moment().format(),
    //   },
    // });
  }, []);

  const columns = React.useMemo(
    () => [
      {
        accessor: "name",

        Header: "DEAL NAME",
        className: "com-name",
      },
      {
        accessor: "views",

        Header: "VIEWS",
        className: "com-loc",
      },
      {
        Header: "CLAIMED",
        accessor: "deals_claimeds_aggregate",
        className: "com-members",
      },
      {
        accessor: "type",

        Header: "TYPE",
        className: "com-events",
      },
      {
        Header: "DATE CREATED",
        accessor: "created_at",
        className: "com-date",
      },
    ],
    []
  );

  useEffect(() => {
    if (activeDealsData && activeDealsData?.deals?.length) {
      let arr = [];
      for (let i = 0; i < activeDealsData?.deals?.length; i++) {
        arr.push({
          name: activeDealsData?.deals[i]?.name,
          views: activeDealsData?.deals[i]?.views_count ?? 0,
          deals_claimeds_aggregate:
            activeDealsData?.deals[i]?.deals_claimeds_aggregate?.aggregate
              ?.count,
          type: activeDealsData?.deals[i]?.type,
          created_at: moment(activeDealsData?.deals[i]?.created_at).format(
            "DD.MM.YYYY"
          ),
        });
      }
      setPageCount(arr.length);
      setData(arr);
      setDataSet(arr);
    }
  }, [activeDealsData]);

  return (
    <MainContainer>
      <section className="settings-section comunites-row">
        <div className="title">
          <div className="back-button">
            <Link to="/dashboard">
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h2>Active Deals</h2>
          </div>
          <div className="download-btn">
            <div className="ml-auto" style={{ marginTop: "-15px" }}>
              <ExcelFile
                element={
                  <img
                    src={download}
                    alt="download icon"
                    style={{ cursor: "pointer" }}
                  />
                }
              >
                <ExcelSheet data={dataSet} name="Transactions">
                  <ExcelColumn label="NAME" value="name" />
                  <ExcelColumn label="VIEWS" value="views" />
                  <ExcelColumn
                    label="CLAIMED"
                    value="deals_claimeds_aggregate"
                  />
                  <ExcelColumn label="TYPE" value="type" />
                  <ExcelColumn label="DATE CREATED" value="created_at" />
                </ExcelSheet>
              </ExcelFile>
            </div>
            {/* <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <img src={download} alt="download icon" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">
                  <span>Export as .CSV</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
          </div>
        </div>
        <div className="comunites-table">
          <div className="table-box">
            <ActiveDealTable
              columns={columns}
              setPageCount={setPageCount}
              pageCount={pageCount}
              data={data}
              getActiveDeals={getActiveDeals}
              loading={activeDealsLoading}
              error={activeDealsError}
            />
          </div>
        </div>
      </section>
    </MainContainer>
  );
};

export default ActiveDealDetails;
